import getters from '@/store/lib/getters'

export default {
  ...getters,

  loginable: (state) => {
    if (state.email === '') return false
    if (state.password === '') return false
    return true
  }
}
